module.exports = __webpack_public_path__ + "static/media/logo.e411744f.svg";